<template>
  <div class="ripeav-login" :style="{background:'url('+'http://'+UrlList+') center center / cover no-repeat '}">
    <div class="all">
      <img src="~@/assets/logo.png" alt="">
      <span>后台管理系统</span>
      <div class="item-info">
        <el-input v-model="user.userName"  prefix-icon="el-icon-user" placeholder="请输入账号" class="item-input" autofocus size="small"></el-input>
        <el-input v-model="user.password"  prefix-icon="el-icon-key" placeholder="请输入密码" show-password class="item-input" size="small"></el-input>
        <div class="submit">
          <el-button size="medium" @click="submit">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data(){
    return {
      user:{},
      UrlList:{},
    }
  },
  created() {
    this.GetUrlData()
  },
  methods:{
    submit() {
      this.$axios.post('/api/user/login',this.user).then(res=>{
        // console.log(res);
        if (res.data.data){
          this.$router.push('/user')
          this.$store.commit('GetLoginStatus')
        }
      })
    },
    GetUrlData(){
      this.$axios.get('/api/photo/getBuildBanana',{params:{
          id:37
        }}).then(res=>{
        this.UrlList=res.data.data[0].photoList[0].address;
        console.log(this.UrlList);
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .ripeav-login{
    height: 100vh;

    background-size:100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .all{
      text-align: center;
      //img{
      //  width: 160px;
      //  height: 90px;
      //}
      span{
        display: block;
        font-size: 36px;
        color: white;
        margin-bottom: 20px;
      }
      .item-info{
        padding: 20px 10px 10px;
        width: 360px;
        height: 200px;
        border: 1px solid #909399;
        border-radius: 5px;
        text-align: center;
        .item-input{
          //padding-left: 10px;
          width: 250px;
          margin: 10px 0;
        }
        .submit{
          margin-top: 20px;
          text-align: center;

        }
      }
    }
  }
</style>